// Auto-generated by scripts/bump-version.js - do not edit manually
export const APP_VERSION = '1.0.564';
export const BUILD_TIMESTAMP = '2026-10-26T05:48:54.455Z';
export const APP_STATUS = 'Production Ready';
export const APP_NAME = 'TeamOne';
